<template>
    <div>
        <el-button class='button' :type="type" @click="createBill()">
            <slot>订单延期</slot>
        </el-button>

        <!--新增、编辑 弹出页面-->
        <dialog-form title="订单延期申请" :formTemplate="formTemplate" :visible.sync="visible" :canEdit="true" :loading="loading"
                    :is-edit="true" :form="form" :rules="rules" :url="url.save" @saved="onSaved()">
        </dialog-form>
    </div>
</template>

<script type="text/javascript">

import DialogForm from '@/components/Dialogs/DialogForm'

export default {
    components: {
        DialogForm
    },
    props: {
        OrderId: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            loading: false,
            active: 0,
            url: {
                save: SZH.assets.api + '/Order/PostOrderDelay',
                get: SZH.assets.api + '/Order/GetOrderDelay',
            },
            rules:{
            },
            form: {
                OrderId: '', Remark: null, Opinion:''
            },
            visible: false,
            formTemplate: [
                { col:24, label: '订单号', prop: 'OrderId', type:'display'   },
                { col:24, label: '当前状态', prop: 'Opinion', type:'display', showByProp: 'Opinion'  },
                { col:24, label: '延期原因', prop: 'Remark', type: 'textarea' },
            ],
        }
    },
    methods: {
        createBill() {
            this.visible = true;
        },
        onSaved() {
            this.$message.success('申请提交成功！');
            this.$emit('saved');
        },
        loadData() {
            var self = this;
            self.$http.post(self.url.get, {
                Data: self.OrderId
            }).then(result => {
                if (result.State == 1) {
                    self.form.Remark = result.Data.Remark;
                    self.form.Opinion = result.Data.OpinionStr;
                } else {
                }
                self.form.OrderId = self.OrderId;
            }, () => {
            });
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
        visible(val) {
            if(val) {
                this.loadData();
            }
        }
    }
}
</script>

<style type="text/css" scoped>
.el-button--text {
    padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Buttons/OrderDelayButton.vue